import { ReactComponent as CustomerSupportSidebarSvg } from "../../assets/images/svgs/customerSupportSidebar.svg";

const CustomerSupportSidebarIcon = ({ className = "", ...props }) => {
  return (
    <CustomerSupportSidebarSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default CustomerSupportSidebarIcon;
